import { render, staticRenderFns } from "./AssetFilters.vue?vue&type=template&id=10b4dcb7&"
import script from "./AssetFilters.vue?vue&type=script&lang=ts&"
export * from "./AssetFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VFlex,VLayout,VSwitch})


/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b4dcb7')) {
      api.createRecord('10b4dcb7', component.options)
    } else {
      api.reload('10b4dcb7', component.options)
    }
    module.hot.accept("./AssetFilters.vue?vue&type=template&id=10b4dcb7&", function () {
      api.rerender('10b4dcb7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/assets/AssetFilters.vue"
export default component.exports